import initializers from 'src/modules/initializers';
import createRootReducer from 'src/modules/reducers';
import { configureStore as confStore } from '@reduxjs/toolkit';

let store;

export function configureStore(preloadedState?) {
  store = confStore({
    reducer: createRootReducer(),
    preloadedState,
    middleware: getDefaultMiddleware => getDefaultMiddleware(),
  });

  for (const initializer of initializers) {
    initializer(store);
  }

  return store;
}

export type AppDispatch = typeof store.dispatch;
export type AppGetState = typeof store.getState;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;

export default function getStore() {
  return store;
}
